import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaTelegram,
  FaPhoneSquare,
  FaGooglePlusSquare,
  FaArrowDown,
  FaPhone,
} from "react-icons/all";
import emailjs from "emailjs-com";
import { motion } from "framer-motion";

const Contact = () => {
  const [emailState, setEmailState] = useState({ success: false, fail: false });
  const [sending, setSending] = useState(false);
  const [tellOpen, setTellOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);

  useEffect(() => {
    const phoneawait = setTimeout(() => {
      setTellOpen(false);
    }, [3000]);
    return () => clearTimeout(phoneawait);
  }, [tellOpen]);

  useEffect(() => {
    const emailawait = setTimeout(() => {
      setEmailOpen(false);
    }, [2000]);
    return () => clearTimeout(emailawait);
  }, [emailOpen]);

  useEffect(() => {
    const wait = setTimeout(() => {
      setEmailState({ success: false, fail: false });
    }, 4000);
    return () => clearTimeout(wait);
  }, [emailState]);

  const alert = (
    <div
      className={`email-alert ${emailState.success ? "sent" : ""}${
        emailState.fail ? "failed" : ""
      }`}
    >
      {`${
        emailState.success === true ? "Your message was successfully sent!" : ""
      }`}
      {`${
        emailState.fail === true ? "Sending failed! Something went wrong!" : ""
      }`}
    </div>
  );

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .sendForm(
        "axel_email_service_id",
        "template_x5hvm0m",
        e.target,
        "user_B5Q35OeNmNPVPSPyviZMv"
      )
      .then(
        (result) => {
          console.log(result.text);
          setEmailState({ success: true, fail: false });
          setSending(false);
        },
        (error) => {
          console.log(error.text);
          setEmailState({ success: false, fail: true });
          setSending(false);
        }
      );
    e.target.reset();
  };

  return (
    <motion.section
      className="contact"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.7 }}
    >
      {tellOpen ? (
        <div className="tell-open">
          <div className="t-o-c">
            <h1>+998 99 987-71-53</h1>
            <a href="Tel:+998 99 987-71-53">
              <FaPhone />
            </a>
          </div>
        </div>
      ) : (
        ""
      )}
      {emailOpen ? (
        <div className="email-open">
          <h1>
            Send your email from here <FaArrowDown />
          </h1>
        </div>
      ) : (
        ""
      )}
      <div>{alert}</div>
      <div className="contact-center">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.7 }}
        >
          Get in touch with me
        </motion.h1>
        <motion.form
          onSubmit={sendEmail}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.7 }}
        >
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder="Your Name (required)"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email (required)"
              required
            />
          </div>
          <input type="text" name="mssg" placeholder="Your Message" required />
          <button className="contact-btn" disabled={sending}>
            {sending ? "Sending..." : "Send Email"}
          </button>
        </motion.form>
      </div>

      {/* footer */}
      <footer className="contact-footer">
        <motion.ul
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.7 }}
        >
          <li>web development and design @ {new Date().getFullYear()}</li>
          <article>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/projects">Projects</Link>
          </article>
        </motion.ul>

        {/* icons */}
        <motion.div
          className="btns-icons"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.7 }}
        >
          <button>
            <a href="https://t.me/Rvse7en">
              <FaTelegram />
            </a>
          </button>
          <button onClick={() => setTellOpen(true)}>
            <FaPhoneSquare />
          </button>
          <button onClick={() => setEmailOpen(true)}>
            <FaGooglePlusSquare />
          </button>
        </motion.div>
      </footer>
    </motion.section>
  );
};

export default Contact;
